import { render, staticRenderFns } from "./ShareStrategyPanel.vue?vue&type=template&id=39bce8db&scoped=true"
import script from "./ShareStrategyPanel.vue?vue&type=script&lang=js"
export * from "./ShareStrategyPanel.vue?vue&type=script&lang=js"
import style0 from "./ShareStrategyPanel.vue?vue&type=style&index=0&id=39bce8db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bce8db",
  null
  
)

export default component.exports